module.exports = __webpack_public_path__ + "img/sh-logo-login-gray.51781afd.svg";